module.exports = __webpack_public_path__ + "img/lenses.96e3adf.png?v=1746012636593";